import { ReferenceBubble } from "@/Shared/ReferenceNumbers/Bubbles/Internal/ReferenceBubble";

export function BoothNumberQuestionBubble(props: {
  displayName?: string | undefined;
  small?: boolean | undefined;
}) {
  return (
    <ReferenceBubble
      small={props.small}
      heading={
        props.displayName
          ? `(Required) Enter the trade show booth number related to your ${props.displayName.toLowerCase()}`
          : `(Required) Enter the trade show booth number`
      }
    />
  );
}
